<div class="footer-container">
  <section name="footer links" class="links">
    <ul class="reset">
      <li><a href="https://www.fracfocus.org" (click)="openLink($event, 'https://www.fracfocus.org')">www.fracfocus.org</a></li>
      <li class="tooltip-wrapper">
        <a href="https://www.fracfocus.org/wells/advanced" (click)="openLink($event, 'https://www.fracfocus.org/wells/advanced')">Find a Well</a>
        <app-popper-tool-tip [popperPlacementParam]="popperPlacement" iconColor="WHITE" screenReaderText="Search for a Submitted Disclosure"></app-popper-tool-tip>
      </li>
      <li><a class="under-530" href="https://fracfocus.org/operators/training" (click)="openLink($event, 'https://fracfocus.org/operators/training')">Training</a></li>
      <li><a class="under-530" href="https://fracfocus.org/operators/operator-faq" (click)="openLink($event, 'https://fracfocus.org/operators/operator-faq')">Operator FAQ</a></li>
    </ul>
  </section>
  <section name="footer gcaptcha" class="gcaptcha">
    <ul class="reset">
      <li class="site">This site is protected by reCAPTCHA and the Google </li>
      <li class="site"><a href="https://policies.google.com/privacy" (click)="openLink($event, 'https://policies.google.com/privacy')">Privacy Policy</a> and </li>
      <li class="site"><a href="https://policies.google.com/terms" (click)="openLink($event, 'https://policies.google.com/terms')">Terms of Service</a> apply.</li>
    </ul>
  </section>
  <section name="footer terms of use" class="terms-of-use">
    <ul class="reset">
      <li class="copyright">&copy; Copyright GWPC, 2023</li>
      <li>
        <a href="/assets/pdf/WEB-SITE-TERMS-AND-CONDITIONS-OF-USE.pdf" (click)="openLink($event, '/assets/pdf/WEB-SITE-TERMS-AND-CONDITIONS-OF-USE.pdf')">Terms of Use</a>
      </li>
      <li>
        <a routerLink="/accessibility-statement">Accessibility Statement</a>
      </li>
    </ul>
  </section>
</div>
